import { createContext, useContext } from 'react';
import type { User } from './api';

/**
 * Who is signed in, and the one way to stop being.
 *
 * Sign-out has to clear the server cookie *and* the app's own state — clearing
 * only the cookie leaves the signed-in routes rendering, which sends a
 * just-signed-out visitor straight back into the app.
 */
export type Auth = {
  user: User | null;
  signOut: () => Promise<void>;
};

const AuthContext = createContext<Auth>({
  user: null,
  signOut: async () => undefined,
});

export const AuthProvider = AuthContext.Provider;

export const useAuth = (): Auth => useContext(AuthContext);
